import React, {PureComponent} from "react"
import {ApolloQueryResult} from "apollo-client"
import gql from "graphql-tag"
import {DocumentNode} from "graphql"

import {Reward} from "@irati/types"
import {Tag} from "@irati/reward/types"
import {Query} from "@irati/utils/services/apollo"

interface Props {
  query: DocumentNode
}

interface Lane {
  type: string,
  rewards: Reward[],
  tags: Tag[]
}

interface Data {
  homePageRewardsLanes: Lane[]
}

export type HomePageRewardsLanesQueryResult = ApolloQueryResult<Data>

const query = gql`
  query HomePageRewardsLanes {
    homePageRewardsLanes {
      type
      rewards {
        uuid
        urlSlug
        header
        cardImage
        thumbnailImage
      }
      tags {
        uuid
        name
      }
    }
  }
`

export default class HomePageRewardsLanesQueryComponent extends PureComponent<Props> {
  static defaultProps = {
    query
  }

  render() {
    return <Query {...this.props} />
  }
}
